import { useState } from "react"
import styled from "styled-components"

import { PlusIcon } from "@minuthq/meatball-ui-icons"
import { spacing } from "@minuthq/meatball-ui-react"

import { CreateTaskDialog } from "src/components/TaskManagement/CreateTaskDialog"
import { TaskCards } from "src/components/TaskManagement/TaskCards"
import { TaskList } from "src/components/TaskManagement/TaskList"
import { usePostCreateTaskInitiated } from "src/data/analytics/queries/taskManagementAnalyticsQueries"
import { useTranslate } from "src/i18n/useTranslate"
import { Routes } from "src/router/routes"
import { MButton } from "src/ui/Button/MButton"
import { MainView } from "src/ui/Layout/MainView"
import { ITab } from "src/ui/Tabs/Tab"
import { TabPanel } from "src/ui/Tabs/TabPanel"
import { Tabs } from "src/ui/Tabs/Tabs"

export function TaskManagementView() {
  const { tPlaceholder } = useTranslate()
  const [openDialog, setOpenDialog] = useState(false)

  const postCreateTaskInitiated = usePostCreateTaskInitiated()

  const tabs: ITab[] = [
    {
      label: tPlaceholder("To do"),
      id: Routes.TodoTasks.location().hash!,
      view: <TaskList taskStatus="todo" />,
    },

    {
      label: tPlaceholder("Completed tasks"),
      id: Routes.CompletedTasks.location().hash!,
      view: <TaskList taskStatus="done" />,
    },
  ]

  function handleClickAddTask() {
    setOpenDialog(true)
    postCreateTaskInitiated.mutate()
  }

  return (
    <MainView
      title={tPlaceholder("Task management")}
      titleBarProps={{
        actionBar: (
          <MButton
            onClick={handleClickAddTask}
            startIcon={<PlusIcon width={20} />}
          >
            {tPlaceholder("Add task")}
          </MButton>
        ),
      }}
    >
      <TaskCards />

      <Tabs labels={tabs}>
        {tabs.map((tab) => (
          <StyledTabPanel key={tab.id}>{tab.view}</StyledTabPanel>
        ))}
      </Tabs>

      {openDialog && <CreateTaskDialog onClose={() => setOpenDialog(false)} />}
    </MainView>
  )
}

const StyledTabPanel = styled(TabPanel)`
  padding-top: ${spacing.XL2};
`
